import { TypeEvent } from '@lexriver/type-event'
import { JsonMap } from "@lexriver/json-map"
import { DataTypes } from '@lexriver/data-types'
import { StringMethods } from "@lexriver/string-methods"
import { GlobalUser } from "../GlobalUser"
import { debounce } from "ts-debounce"
import { JsonProduct } from '../json-data-types/JsonProduct'
import { EnumWebsocketPushMessages, RequestMaker } from '../server-queries/RequestMaker'
import { IFavorites } from './IFavorites'
import { IFavoritesGetResult } from './IFavoritesGetResult'
import { GlobalFavorites } from '../GlobalFavorites'

const filename = 'FavoritesOnServer'

export class FavoritesOnServer implements IFavorites {
    static countOfInstances = 0
    //protected productIds = new JsonMap<JsonBasketProductInfo, number>()
    protected productIds:number[] = []
    
    public onChangeEvent: TypeEvent<() => void> = new TypeEvent()
    public onFavoritesEmptyOrNotEvent: TypeEvent<(isEmpty: boolean) => void> = new TypeEvent()
    protected prevIsEmpty: boolean = true
    protected _isInitialized: boolean = false
    
    constructor() {
        FavoritesOnServer.countOfInstances++

        this.subscribeToTriggerFavoritesEmptyOrNotEvent()
        this.subscribeToPushMessages()
        this.subscribeToUserChangeEvent()

        setTimeout(() => {
            this.initAsyncDebounced()
        }, 2000)
        
    }
    getTotalQuantity(): number {
        return this.productIds.length
    }
    getProductIds(): number[] {
        return this.productIds
    }

    async hasProductIdAsync(productId: number): Promise<boolean> {
        return this.productIds.indexOf(productId)>=0
    }


    protected subscribeToUserChangeEvent(){
        GlobalUser.eventUserLoggedOut.subscribe(async () => {
            await this.onChangeEvent.triggerAsync()
        })
        GlobalUser.eventUserLoggedIn.subscribe((user) => {
            this.initAsyncDebounced()
        })
        GlobalUser.loggedInUserO.eventOnChange.subscribe(() => {
            this.initAsyncDebounced()
        })

    }

    /**
     * Favorites empty or not event
     */
    protected subscribeToTriggerFavoritesEmptyOrNotEvent(){
        this.onChangeEvent.subscribe(async () => {
            // console.log('BasketOnServer', 'onChangeEvent!')
            //console.log('Basket.ts onChangeEvent')
            const isEmptyNow = this.productIds.length == 0
            //console.log('prevIsEmpty=', this.prevIsEmpty, 'isEmptyNow=', isEmptyNow)
            if (this.prevIsEmpty !== isEmptyNow) {
                //console.log('Basket.ts triggering onBasketEmptyOrNotEvent')
                await this.onFavoritesEmptyOrNotEvent.triggerAsync(isEmptyNow)
                this.prevIsEmpty = isEmptyNow
            }
        })
    }

    /**
     * Subscribe to change internal products ids by push message
     */
    protected subscribeToPushMessages(){
        // on quantity update event:
        RequestMaker.subscribeToPushMessage(EnumWebsocketPushMessages.FavoritesUpdate, async (params:any) => {
            //console.log('BasketOnServer on push message', EnumWebsocketPushMessages.FavoritesUpdate, params)
            // check params
            if(DataTypes.isArray(params.productIds)) {//TODO or params.productIds?
                //ok
            } else {
                console.error('wrong params for', EnumWebsocketPushMessages.FavoritesUpdate, params)
                return
            }

            this.productIds = params.productIds
            void this.onChangeEvent.triggerAsync()
            
            if(this.getHash() !== params.hash){
                console.warn('favorites hash is not the same, so query full favorites', this.getHash(), params.hash)
                this.initAsyncDebounced()
            }
        })
        

        // on clear event
        RequestMaker.subscribeToPushMessage(EnumWebsocketPushMessages.FavoritesUpdate, async (params:{productIds:number[], hash:number}) => {
            if(this.getHash() !== params.hash){
                this.productIds = params.productIds
                await this.onChangeEvent.triggerAsync()
            }
        })

    }

    getWarningMessageOnRemovingObsoleteProducts(countOfProducts:number){
        return StringMethods.formatPluralNumber({
            number: countOfProducts,
            settings: {
                locale: 'ru',
                ifZero:(x)=>null,
                ifOne:(x)=>`Из избранного был удален 1 товар, так как его больше нет в наличии`,
                ifFew:(x)=>`Из избранного было удалено ${x} товара, так как их больше нет в наличии`,
                ifMany:(x)=>`Из избранного было удалено ${x} товаров, так как их больше нет в наличии`
            }
        })
    }


    protected initAsyncDebounced = debounce(this.initAsync, 1000)
    protected async initAsync(){
        //console.log('BasketOnServer: initAsync()')
        if(await GlobalUser.checkIfLoggedInAsync() === false) {
            // skip if user is not logged in
            //return
        } else {
            //console.log('---> sessionId=', GlobalUser.sessionIdO.get())
            const response:IFavoritesGetResult = await RequestMaker.sendWebsocketJsonRequestAsync({query:'favorites'}, this)

            // console.log('BasketOnServer:', 'basket=', basket, 'obsoleteProductsRemovedCount=', obsoleteProductsRemovedCount)
            if(response.removedObsoleteCount>0){
                console.warn(this.getWarningMessageOnRemovingObsoleteProducts(response.removedObsoleteCount))
                // alert(this.getWarningMessageOnRemovingObsoleteProducts(response.removedObsoleteCount))
            }
            if(response.productIds){
                this.productIds = response.productIds
            }
            await this.mergeFromAnonymousFavoritesAsync()

        }
        await this.onChangeEvent.triggerAsync()

        this._isInitialized = true
        //console.log('BasketOnServer: initAsync()', 'this._isInitialized=', this._isInitialized, 'loggedInUser=', GlobalCurrentUser.loggedInUserO.get())
    }

    protected async mergeFromAnonymousFavoritesAsync(){
        const anonymousProductIds = GlobalFavorites.anonymousFavorites.getProductIds()
        
        for(let productId of anonymousProductIds){
            await this.addAsync(productId)
        }
        //console.log('((', 'added from anonymous basket', anonymousProducts.length)
        await GlobalFavorites.anonymousFavorites.clearAsync()
        
    }

    
        
    async addAsync(productId: number): Promise<boolean> {
        try {
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'favorites-add', params:{
                productId
            }}, this)
            return true

        } catch(x){
            console.error(filename, 'addAsync failed', x)
        }
        return false
    }


    async removeAsync(productId: number): Promise<boolean> {
        try {
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'favorites-delete', params:{productId}}, this)
            //this.onChangeEvent.triggerAsync()
            return true
        } catch(x){
            console.error(filename, 'removeAsync failed', x)
        }
        return false

    }

    protected productIdsToRemove = new Set<number>()
    markProductToRemove(productId:number){
        this.productIdsToRemove.add(productId)
    }

    unmarkProductToRemove(productId:number){
        this.productIdsToRemove.delete(productId)
    }

    unmarkAllProducts(){
        this.productIdsToRemove.clear()
    }


    async removeMarkedProductsAsync():Promise<void>{
        for(let productId of this.productIdsToRemove){
            await this.removeAsync(productId)
        }
        this.productIdsToRemove.clear()
    }

    async clearAsync() {
        try {
            const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'favorites-clear'}, this)
            // console.log(filename, 'clearAsync response=', response)
            //this.onChangeEvent.triggerAsync()
            return true
        } catch(x){
            console.error(filename, 'clearAsync()', x)
        }
        return false
    }

    toJsonString(): string {
        return JSON.stringify(this.productIds)
    }

    initFromJsonString(jsonString: string) {
        //const asArray = JSON.parse(jsonString)
        this.productIds = JSON.parse(jsonString)
    }

    getHash(): number {
        return StringMethods.getSimpleHash(this.toJsonString())
    }

    isEmpty() {
        //console.log('@@ this.quantityByProductInfostring=', this.quantityByProductInfoString)
        return this.productIds.length == 0
    }

    isInitialized(){
        return this._isInitialized
    }



}
